module.exports = __webpack_public_path__ + "img/paso_3.7af0043a.png";